// ============================================================================
// KOREAN TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// 성찰을 위한 재미있는 질문들

export const funQuestionsKo = [
  {
    question: "예수님의 사랑의 행동 중 당신의 일상에 가장 큰 감동을 주는 것은 무엇인가요?",
    emoji: "❤️",
    theme: "사랑"
  },
  {
    question: "하나님의 창조물 중 당신에게 가장 하나님의 위대함을 보여주는 것은 무엇인가요?",
    emoji: "🌟",
    theme: "창조"
  },
  {
    question: "어려운 시기에 당신에게 위로를 준 성경 구절은 무엇인가요?",
    emoji: "🕊️",
    theme: "위로"
  },
  {
    question: "성경 인물 중 누구의 삶에서 가장 큰 영감을 받나요? 그 이유는?",
    emoji: "⭐",
    theme: "영감"
  },
  {
    question: "당신의 삶에서 하나님께 가장 감사한 축복은 무엇인가요?",
    emoji: "🙏",
    theme: "감사"
  },
  {
    question: "예수님의 비유 중 어떤 것이 당신의 영적 여정에 가장 큰 영향을 주었나요?",
    emoji: "📖",
    theme: "가르침"
  },
  {
    question: "하나님의 성품 중 어떤 측면이 당신에게 가장 의미가 있나요? (사랑, 정의, 자비...)",
    emoji: "✨",
    theme: "성품"
  },
  {
    question: "당신의 믿음이 예상치 못한 방식으로 강해진 순간은 언제인가요?",
    emoji: "💪",
    theme: "믿음"
  }
];

export default funQuestionsKo;
